import {TEST_TYPES} from 'constants/index';

const childTypes = [
	TEST_TYPES.CHILD_FOLLOWUP,
	TEST_TYPES.YOUTH_FOLLOWUP,
	TEST_TYPES.ADULT_FOLLOWUP,
	'child',
];

export default function getTestResultPath(
	type,
	id,
	testVersion,
	{isNorming = false} = {}
) {
	if (type === TEST_TYPES.CHILD_EXPERIMENTAL) {
		return `/single-speech-test/${id}`;
	}

	const isChildType = childTypes.includes(type);

	if (testVersion === 'v2') {
		return isChildType
			? `/followup-test-dld/${id}`
			: `/screening-test-dld/${id}`;
	}

	if (isNorming) {
		return isChildType
			? `/followup-test-norming/${id}`
			: `/screening-test-norming/${id}`;
	}

	return isChildType
		? `/single-child-test/${id}`
		: `/single-test/${id}`;
}
